import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddEventAccountToEventParticipantsMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  event_account_id: Types.Scalars['ID'];
}>;


export type AddEventAccountToEventParticipantsMutation = { __typename?: 'Mutation', addEventAccountToEventParticipants: { __typename?: 'Event', id: string, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null } };


export const AddEventAccountToEventParticipantsDocument = gql`
    mutation AddEventAccountToEventParticipants($event_id: ID!, $event_account_id: ID!) {
  addEventAccountToEventParticipants(
    event_id: $event_id
    event_account_id: $event_account_id
  ) {
    id
    name
    description
    image_url
    start_date
    end_date
  }
}
    `;
export type AddEventAccountToEventParticipantsMutationFn = Apollo.MutationFunction<AddEventAccountToEventParticipantsMutation, AddEventAccountToEventParticipantsMutationVariables>;

/**
 * __useAddEventAccountToEventParticipantsMutation__
 *
 * To run a mutation, you first call `useAddEventAccountToEventParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventAccountToEventParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventAccountToEventParticipantsMutation, { data, loading, error }] = useAddEventAccountToEventParticipantsMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_account_id: // value for 'event_account_id'
 *   },
 * });
 */
export function useAddEventAccountToEventParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<AddEventAccountToEventParticipantsMutation, AddEventAccountToEventParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventAccountToEventParticipantsMutation, AddEventAccountToEventParticipantsMutationVariables>(AddEventAccountToEventParticipantsDocument, options);
      }
export type AddEventAccountToEventParticipantsMutationHookResult = ReturnType<typeof useAddEventAccountToEventParticipantsMutation>;
export type AddEventAccountToEventParticipantsMutationResult = Apollo.MutationResult<AddEventAccountToEventParticipantsMutation>;
export type AddEventAccountToEventParticipantsMutationOptions = Apollo.BaseMutationOptions<AddEventAccountToEventParticipantsMutation, AddEventAccountToEventParticipantsMutationVariables>;